import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const format = 'DD/MM/YYYY';

const NextTimePayment = ({ packageExpiryDate }) => {
  const { t } = useTranslation();

  const formatterPackageExpiryDate = moment(packageExpiryDate).format(format);

  return (
    <Box className="content-item">
      <Typography className="label">{t('nextPayment')}</Typography>
      <Typography className="content">{formatterPackageExpiryDate}</Typography>
    </Box>
  );
};

export default NextTimePayment;
